{
  "es": {
    "inspiration_list": {
      "actions": {
        "cancel": "Deshacer",
        "delete": "Eliminar",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "new": "Nuevo álbum de fotos",
        "save": "Guardar",
        "submit": "Guardar",
        "tickBoxesDeletion": "Marca las casillas de los archivos que quieras eliminar."
      },
      "attributes": {
        "name": "Nombre"
      },
      "info": "¿Qué te gusta para tu nueva vivienda? Sube fotos que te inspiren. Los álbumes te permiten organizarlas por temas: cocina, baño, muebles...",
      "labels": {
        "inspiration_list": "Listas de inspiración",
        "inspirationlist": "Álbum de inspiración",
        "inspirations": "Inspiraciones",
        "noInspirationLists": "Aún no hay listas de inspiración",
        "noInspirations": "Aún no hay inspiraciones"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Crea distintos álbumes para tu cocina, baño o muebles y sube fotos que te inspiren.",
            "title": "¿Cómo decorarás tu nueva vivienda?"
          }
        }
      },
      "validation": {
        "needTitle": "El título es obligatorio",
        "selectInspirationList": "Selecciona al menos 1 lista de inspiración"
      }
    }
  }
}
